import {
    ADD_RESERVATION,
    ADD_RESERVATION_SUCCESS,
    ADD_RESERVATION_FAILURE,
    RESET_ADD_RESERVATION_STATE,
    GET_RESERVATIONS,
    GET_RESERVATIONS_SUCCESS,
    GET_RESERVATIONS_FAILURE,
    RESET_RESERVATION_ACTIONS_STATE,
    CREATE_ACCESS_API_START_OVER,
    STORE_GUARD_RESERVATION_ID,
    END_PANEL_CALL_SUCCESS
} from '../actions/types';

const INITIAL_STATE = {
    addingReservation: false,
    addingReservationSuccess: false,
    addingReservationError: null,
    cancellingReservation: false,
    cancellingReservationSuccess: false,
    cancellingReservationError: null,
    reinstatingReservation: false,
    reinstatingReservationSuccess: false,
    reinstatingReservationError: null,
    updatingReservation: false,
    updatingReservationSuccess: false,
    updatingReservationError: null,
    reservations: [],
    loadingReservations: false,
    loadingReservationsError: null,
    validatingReservation: false,
    validationSuccess: null,
    validationError: null,
    addingTenant: false,
    addingTenantSuccess: false,
    addingTenantError: null,
    guardReservationId: null
};

const reservationReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ADD_RESERVATION:
            return {
                ...state,
                addingReservation: true,
                addingReservationError: null,
                addingReservationSuccess: false
            };
        case ADD_RESERVATION_SUCCESS:
            return {
                ...state,
                addingReservation: false,
                addingReservationSuccess: true
            };
        case ADD_RESERVATION_FAILURE:
            return {
                ...state,
                addingReservation: false,
                addingReservationSuccess: false,
                addingReservationError: action.payload
            };
        case RESET_ADD_RESERVATION_STATE:
            return {
                ...state,
                addingReservation: false,
                addingReservationSuccess: false,
                addingReservationError: null
            };
        case GET_RESERVATIONS:
            return {
                ...state,
                loadingReservations: true,
                loadingReservationsError: null
            };
        case GET_RESERVATIONS_SUCCESS:
            return {
                ...state,
                loadingReservations: false,
                reservations: action.payload
            };
        case GET_RESERVATIONS_FAILURE:
            return {
                ...state,
                loadingReservations: false,
                loadingReservationsError: action.payload
            };
        case RESET_RESERVATION_ACTIONS_STATE:
            return {
                ...state,
                cancellingReservation: false,
                cancellingReservationSuccess: false,
                cancellingReservationError: null,
                reinstatingReservation: false,
                reinstatingReservationSuccess: false,
                reinstatingReservationError: null,
                updatingReservation: false,
                updatingReservationSuccess: false,
                updatingReservationError: null
            };
        case CREATE_ACCESS_API_START_OVER:
            return {
                ...state,
                addingTenantSuccess: INITIAL_STATE.addingTenantSuccess
            };
        case STORE_GUARD_RESERVATION_ID:
            return {
                ...state,
                guardReservationId: action.payload
            };
        case END_PANEL_CALL_SUCCESS:
            return {
                ...state,
                guardReservationId: INITIAL_STATE.guardReservationId
            };
        default:
            return state;
    }
};

export default reservationReducer;
